{
  "02a4fc7c14fd1f99": "Please provide at least 30 characters",
  "09adde92f00886ef": "Clock in",
  "0b69226a13ae20dd": "This shift has a pending Missed Punch Request. Please correct and approve or decline the MPR before making shift adjustments.",
  "155f816c0407310c": "Submit",
  "19766ed6ccb2f4a3": "Cancel",
  "1d43329e847494c8": "Generate Unsigned Missed Punch Request",
  "36da52013a723f9c": "Failed to load shift state",
  "4384a9db2738d8fd": "Missed Punch Request Required",
  "45733af728fba90d": "Clock out",
  "54c7049be8221356": "Failed to load shift details",
  "57cf1b694598e578": "View Missed Punch Request",
  "5d78d3c01a7f3a10": "\"Request shift payment\" and follow the steps to get paid for this shift.",
  "5e268c8f9361afbb": "One of the following two cases applies: The workplace has approved this shift time increase OR the shift is not actually",
  "638f63b642280192": "This clock-in is before the worker's arrival time or clock-out is after the departure time. Submitting will override the geofence boundary.",
  "8016267a5d2d907d": "Failed to submit unsigned missed punch request",
  "8f227bc8dd1f19c3": "Clock in time",
  "a082fd30d7c96141": "Add the reason for missing clock in/out from the worker",
  "a2578cd365b13e34": "Unsigned missed punch request submitted successfully",
  "a745945a992b3f06": "To request a change for this shift, please adjust at least one time field",
  "a8ab24521afb3b26": "One of the following two cases applies: The workplace has approved this shift adjustment OR the shift is not actually",
  "c6f4af27d3c0ec8e": "MPR eligible",
  "c9c8084eb6d3d632": "Please note that this shift has an approved MPR. Kindly review the details carefully before proceeding with any adjustments.",
  "caed89bf40fc2c84": "It is not allowed to process a paper timesheet on this shift.",
  "dc5922e62a919fe5": "It is not allowed to process a paper timesheet on this shift. Please ask the professional to go to Shift History",
  "e005cecbc48072c2": "Clock out time",
  "f3d8b1c69d1dd7ba": "Failed to load workplace shift details",
  "f81ab834de5f8491": "Reason",
  "fca73138f1f51921": "Reason for missed punch request"
}
